<template>
  <div>
    <Loading :isLoading="this.isLoading"/>
    <Modal v-if="showModalListConcepts" :widthContainer="'50%'" :heightContainer="'50%'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#179099;">Lista de Conceptos de Devolución</h3>
      <div slot="body">
        <div class="">
          <div class="grid grid-cols-1 gap-4">
            <div style="border: 1px solid #179099;padding:10px;margin-top:10px;" v-for="(concept, i) in concepts" :key="i">
              <p style="text-align:left;font-family:Roboto;
                font-size:18px;font-weight:500;">Resumen: <span style="font-weight:400;">{{concept.concept_name}}</span></p>
              <p style="text-align:left;font-family:Roboto;
                font-size:18px;font-weight:500;">Quincenas Descontadas: <span style="font-weight:400;">{{concept.fortnights_to_return}}</span></p>
              <p style="text-align:left;font-family:Roboto;
                font-size:18px;font-weight:500;">Importe Solicitado: <span style="font-weight:400;">{{concept.refund_amount | currency}}</span></p>
              <p v-if="concept.description != ''" style="text-align:left;font-family:Roboto;margin-top:20px;
                font-size:18px;font-weight:500;">Descripción: <br/><span style="font-weight:400;">{{concept.description}}</span></p>
            </div>
            <div>
              <p style="text-align:center;font-family:Roboto;margin-top:20px;
                font-size:20px;font-weight:500;">Total: <span style="font-weight:400;">{{getTotalRefundSelected() | currency}}</span></p>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding:0px !important">
        <input type="button" value="Cerrar" class="closeModalButton" v-on:click="showModalListConcepts = false">
      </div>
    </Modal>
    <Modal v-if="showModalListDocuments" :widthContainer="'50%'" :heightContainer="'50%'">
      <h3 slot="header" style="font-weight:500;font-size:24px;font-family:Roboto;color:#179099;">Lista de Documentos Cargados</h3>
      <div slot="body">
        <div class="">
          <p style="font-weight:500;font-size:20px;font-family:Roboto;margin-bottom:30px;">De Click sobre el elemento de un Documento para visualizarlo.</p>
          <div class="grid grid-cols-1 gap-4" style="border: 1px solid #179099;padding:10px;margin-top:10px;"
           v-for="(document, index) in documents_list" :key="index">
           <a v-on:click="viewDocument(document.url)" style="cursor:pointer;text-decoration:none">
             <div style="">
                <p style="width:70%;text-align:left;font-family:Roboto;
                  font-size:18px;font-weight:500;">{{documentsAbbreviationEnum[document.abbreviation]}}:</p>
                <p style="width:70%;word-wrap: break-word;text-align:left;font-family:Roboto;
                  font-size:18px;font-weight:300;">
                  {{`${document.document_name}.${document.extension}` }}
                </p>
              </div>
           </a>
          </div>
        </div>
      </div>
      <div slot="footer" style="padding:0px !important">
        <input type="button" value="Cerrar" class="closeModalButton" v-on:click="showModalListDocuments = false">
      </div>
    </Modal>
    <div style="margin-top:30px;">
      <ReedirectButton />
    </div>
    <FilterButtons ref="filterButtonsComponent" :list_to_filter="requests" 
      v-on:filter-list-by-status="getRequestsFiltered($event)" />
    <div style="clear: both;"></div>
    <div style="margin-top:30px;" id="pendingRequest">
      <div>
        <p style="text-align:left;font-size:24px;color: #6B6969;font-weight:bold;font-family:Roboto;">{{descriptionText}}</p>
      </div>
      <div class="flex" style="margin-top:30px;">
        <SearchByRfc ref="searchByRfcComponent" :list_to_filter="requests"
          v-on:filter-info-by-rfc="getListFilteredByRfc($event)" />
      </div>
      <div class="flex" style="margin-top:30px;" v-if="requestsFiltered.length <= 0">
        <p class="description">No se encontraron registros</p>
      </div>
      <table class="table tableRefundRequests" id="table-id" style="margin-top:20px;">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th v-on:click="sortTable('rfc')">
              <div class="grid grid-cols-2">
                <div>
                  RFC
                </div>
                <div>
                  <div class="arrow" v-if="'rfc' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('email')">
              <div class="grid grid-cols-2">
                <div>
                  EMAIL
                </div>
                <div>
                  <div class="arrow" v-if="'email' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('cellphone')">
              <div class="grid grid-cols-2">
                <div>
                  CELULAR
                </div>
                <div>
                  <div class="arrow" v-if="'cellphone' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('interbank_clabe')">
              <div class="grid grid-cols-2">
                <div>
                  CLABE INTERBANCARIA
                </div>
                <div>
                  <div class="arrow" v-if="'interbank_clabe' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('bank_name')">
              <div class="grid grid-cols-2">
                <div>
                  BANCO
                </div>
                <div>
                  <div class="arrow" v-if="'bank_name' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th v-on:click="sortTable('created_at')">
              <div class="grid grid-cols-2">
                <div>
                  FECHA DE REGISTRO
                </div>
                <div>
                  <div class="arrow" v-if="'created_at' == sortColumn" v-bind:class="[ascending ? 'asc' : 'dsc']"></div>
                </div>
              </div>
            </th>
            <th></th>
            <th></th>
            <th v-if="statusFilter != 'aceptado'"></th>
            <th v-if="statusFilter == 'pendiente'"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in requestsFiltered" :key="item.id">
            <td>{{index+1}}</td>
            <td>{{item.rfc | capitalize}}</td>
            <td>{{item.email}}</td>
            <td>{{item.cellphone}}</td>
            <td>{{item.interbank_clabe}}</td>
            <td>{{item.bank_name}}</td>
            <td>{{item.created_at | moment}}</td>
            <td style="padding-left:0px;"><input type="button" class="viewHistory" value="Documentos Cargados" id="button_document_attached" v-on:click="getDocumentsByRefundId(item.id)" /></td>
            <td style="padding-left:0px;"><input type="button" class="viewHistory" value="Ver Conceptos de Devolución" id="button_see_concepts" v-on:click="getConceptpsByRequest(item.concepts)" /></td>
            <td v-if="statusFilter != 'aceptado'" style="padding-left:0px;"><input type="button" class="acceptRequest" value="Capturar" id="button_capture" v-on:click="captureRequest(item.rfc)" /></td>
            <td v-if="statusFilter == 'pendiente'" style="padding-left:0px;"><input type="button" class="rejectRequest" value="Rechazar" id="button_reject" v-on:click="rejectRequest(item)" /></td>
          </tr>
        </tbody>
      </table>
      <div v-show="requestsFiltered.length > elementsPerPage" class='pagination-container' style="text-align:center;">
        <nav>
          <ul class="pagination pagination-requests">
            <li data-page="prev" style="cursor: pointer;">
              <span>Anterior<span class="sr-only">(current)</span></span>
            </li>
            <li data-page="next" id="prev" style="cursor: pointer;">
              <span>Siguiente<span class="sr-only">(current)</span></span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/classes/User'
import Refund from '@/classes/Refund'
import Document from '@/classes/Document'

import { getPagination, filterByStatus } from '@/helpers/tablePagination'

import Swal from 'sweetalert2'
import FilterButtons from '@/components/FilterButtons/FilterButtons.vue'
import SearchByRfc from '@/components/Search/SearchByRfc.vue'
import Loading from '@/components/Loading/Loading.vue'
import ReedirectButton from '@/components/Forms/ReedirectButton.vue'
import Modal from '@/components/Modal/Modal.vue'

import { descriptionRequestText, documentsAbbreviation } from '@/helpers/enums'
import {sendMailNotificationClient, bodyEmailNotificationClient} from '@/helpers/email'
import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
      isLoading: false,
      token_auth: "",
      rfc: "",
      requests: [],
      requestsFiltered: [],
      sortColumn: "",
      ascending: false,
      statusFilter: "pendiente",
      elementsPerPage: 10,
      descriptionText: "Solicitudes Pendientes",
      documents_list: [],
      concepts: [],
      showModalListDocuments: false,
      showModalListConcepts: false,
      documentsAbbreviationEnum: documentsAbbreviation,
      userObjectClass: null,
      documentObjectClass: null,
      refundObjectClass: null,
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
    }
  },
  name: 'RefundForDiscountRequestedComponent',
  components: {
    FilterButtons,
    Loading,
    SearchByRfc,
    ReedirectButton,
    Modal
  },
  mounted() {
    this.userObjectClass = new User();
    this.refundObjectClass = new Refund();
    this.documentObjectClass = new Document();
    this.login();
  },
  methods: {
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.token_auth = response.data.token_auth;
        console.log(this.token_auth);
        this.getRequests().then(response => {
          this.$refs.filterButtonsComponent.filterByStatus("pendiente");
        });

        this.isLoading = false;
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      })
    },
    async getRequests() {
      return await this.refundObjectClass.getAll(this.token_auth, 'periodo de solicitudes de descuentos indebidos').then(response => {
        console.log(response.data.response.undue_discount_request);
        this.requests = response.data.response.undue_discount_request;
        // this.requestsFiltered = response.data.response.retirement_request;
        console.log(this.requests);
      }).catch(error => {
        console.error(error);
      });
    },
    async setRefundRequestFiltered(requestFiltered) {
      this.requestsFiltered = requestFiltered;
      console.log("filtered:", this.requestsFiltered);
    },
    getRequestsFiltered(event) {
      console.log("status:", event.status);
      this.statusFilter = event.status;
      this.changeDescriptionText(event.status);
      this.setRefundRequestFiltered(event.data).then(response => {
        getPagination("#table-id", ".pagination-requests", "#prev", "#maxRows", this.elementsPerPage, this.requestsFiltered.length);
      });
    },
    changeDescriptionText(buttonSelected) {
      this.descriptionText = descriptionRequestText[buttonSelected];
    },
    getListFilteredByRfc(event) {
      console.log("filter by rfc: ", event);
      let requestFilteredByStatus = filterByStatus(event, 'status', this.statusFilter);
      this.setRefundRequestFiltered(requestFilteredByStatus).then(response => {
        getPagination("#table-id", ".pagination-requests", "#prev", "#maxRows", this.elementsPerPage, this.requestsFiltered.length);
      });
    },
    async getDocumentsByRefundId(requestId) {
      try {
        this.isLoading = true;
        let response = await this.refundObjectClass.document.getRefundDocumentsAttached(this.token_auth, requestId);
        this.isLoading = false;
        this.documents_list = response.data.response.undue_discount_request;
        this.showModalListDocuments = true;
        console.log("documents:", this.documents_list);
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "warning",
        })
      }
    },
    rejectRequest(request) {
      Swal.fire({
        title: "Aviso",
        customClass: {
          container: 'my-swal'
        },
        text: "¿Desea rechazar la solicitud?",
        html: `<p style="font-size:18px;">¿Desea rechazar la solicitud con RFC: <span style="font-weight:bold;">
          ${request.rfc}</span>?</p>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      })
      .then((result) => {
        if (result.value) {
          this.isLoading = true;

          this.refundObjectClass.reject(this.token_auth, request.id).then(response => {
            let bodyEmail = bodyEmailNotificationClient("Confirmación de Solicitud",`Su Solicitud de Reembolso ha sido rechazada.`, 'http://200.92.206.58:90/refund-for-discount/refund-for-discount-request');

            sendMailNotificationClient(request.email, "Notificación Solicitud de Reembolso", bodyEmail, "").then(response =>{
              this.isLoading = false;
              this.getRequests().then(response => {
                this.$refs.filterButtonsComponent.filterByStatus(this.statusFilter);
              });
              Swal.fire({
                html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Reembolso ha sido rechazada correctamente</p>`,
                confirmButtonText: "Continuar",
                allowOutsideClick: false,
                icon: "success",
              })
            }).catch(error => {
              this.isLoading = false;
              Swal.fire({
                title: "Aviso",
                text: error,
                icon: "warning",
              })
            });
          }).catch(error => {
            this.isLoading = false;
            Swal.fire({
              title: "Aviso",
              text: error,
              icon: "error",
            })
          });
        }
      })
      this.setIdAttributeToAccepAndCancelButtonSwalFire('button_confirm_reject', 'button_cancel_reject');
    },
    getConceptpsByRequest(concepts) {
      this.concepts = concepts;
      console.log(concepts);
      this.showModalListConcepts = true;
    },
    getTotalRefundSelected() {
      return this.concepts.map(a => a.refund_amount).reduce((a, b) => a + b, 0);
    },
    captureRequest(rfc){
      try {
        this.isLoading = true;
        window.location.href = "http://172.16.201.7/agregardevoluciones.asp?rfcseleccionado="+rfc
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: "Error al redireccionar a la captura de devolucion",
          icon: "error",
        })
      }
    },
    viewDocument(url) {
      window.open(url,'_blank');
    }
  },
}
</script>